// extracted by mini-css-extract-plugin
export default {"font-renta":"FormReceivers_font-renta__Ysevw","formReceivers":"FormReceivers_formReceivers__jh3Zo","receiverContainer":"FormReceivers_receiverContainer__6-ElU"};